import "./Css/styles.css"

const Loading = ({type = "normal"}) => {
  switch (type){
    case "normal":
      return (
        <div className="center">
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        </div>
      );
    case "small":
      return (
        <div className="center">
          <div className="spinner-container">
            <div className="loading-spinner-small"></div>
          </div>
        </div>
      );
    default:
      return <></>
  }
 
};
export default Loading;